import { PortalRequest as request } from "@/utils/request";

export const getHomepageBanner = () => {
  return request({
    url: `/ad/homepage/banner/list-all`,
    method: "get",
  });
};
